import { render, staticRenderFns } from "./TextBoxWrapperObject.vue?vue&type=template&id=daca8796&scoped=true&"
import script from "./TextBoxWrapperObject.vue?vue&type=script&lang=ts&"
export * from "./TextBoxWrapperObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daca8796",
  null
  
)

export default component.exports